module.exports = __webpack_public_path__ + "img/vegetable-yams-190x100.f8928012.jpg";